import { act } from "react-test-renderer";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ExistingContributionDispatcher } from "./Variable";

export interface ExistingContributionStaticState {
    actionType: ActionType;
    isLoading: boolean;
    contribution: PensionContributionModel;
}

export class ExistingContributionStatic extends BaseStore<ExistingContributionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ExistingContributionDispatcher, (actionData) => 
        this.onExistingContributionResponse(actionData))
    }
    
    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }
    protected getDefaultState(): ExistingContributionStaticState {
        return { actionType: ActionType.Loading, isLoading: true, contribution: null }
    }

    public getExistingContribution(): PensionContributionModel {
        return this.getState().contribution;
    }

    private onExistingContributionResponse(actionData): void {
        switch(actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.ActionType, contribution: actionData.payload});
                break;
            default:
                this.setState({ actionType: actionData.actionType, contribution: null, isLoading: true });
                break;
        }
    }
}